"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var JourneyTypes_1 = require("../../../../common/enum/JourneyTypes");
var useDealStatusAssertion_1 = require("../../common/react/useDealStatusAssertion");
var ConfirmationReserveOnlineScreen_1 = require("./reserveOnline/ConfirmationReserveOnlineScreen");
var useDataLayerOnConfirmation_1 = require("../../common/react/useDataLayerOnConfirmation");
var ReserveOnlineConfirmationScreen = function () {
    var _a;
    useDealStatusAssertion_1.default((_a = {},
        _a[JourneyTypes_1.JourneyTypes.RESERVE_ONLINE] = 4000,
        _a[JourneyTypes_1.JourneyTypes.CONTINUE_IN_DEALERSHIP] = false,
        _a[JourneyTypes_1.JourneyTypes.ORDER_ONLINE] = false,
        _a));
    useDataLayerOnConfirmation_1.default('reserveConfirmation');
    return <ConfirmationReserveOnlineScreen_1.default />;
};
exports.default = ReserveOnlineConfirmationScreen;
